import React from "react"; 
import { Tooltip } from "../common/svg";


//-- Tooltip Props 
//-- position: top, left, right, bottom, bottom-left (type: str) 
//-- sizeContent: width of content tooltip (type: str)
//-- desc: JSX
//-- [default]: s 

const getPositionClg = (position) => {
    switch (position) {
        case "bottom": 
            return "tooltip-bottom"
        case "bottom-left": 
            return "tooltip-bottom-left"
        case "bottom-right": 
            return "tooltip-bottom-right"
        case "left":
            return "tooltip-left"
        case "right": 
            return "tooltip-right"
        case "top": 
        default: 
            return ""
    }
}

export const TooltipP = ({title, desc, sizeContent, position, icSize}) => {

    const sizeClg = sizeContent === "M" ? "tooltip--m" : ""
    const positionClg = getPositionClg(position)

    return (
        <p className="df-align-center">
            {title}
            <span className={`tooltip ${sizeClg} ${positionClg}`}>
                <span className="wrap-svg">
                    <Tooltip />
                </span>
                <span className="tooltip-text">{desc()}</span>
            </span>
        </p>
    )
}

export const TooltipH = ({title, desc, sizeContent, position}) => {

    const sizeClg = sizeContent === "M" ? "tooltip--m" : ""
    const positionClg = getPositionClg(position)

    return (
        <h6 className="df-align-center">
            {title}
            <span className={`tooltip ${sizeClg} ${positionClg} icon--m`}>
                <span className="wrap-svg">
                    <Tooltip />
                </span>
                <span className="tooltip-text">{desc()}</span>
            </span>
        </h6>
    )
}

export const TooltipLabel = ({ id, title, desc, sizeContent, position}) => {

    const sizeClg = sizeContent === "M" ? "tooltip--m" : ""
    const positionClg = getPositionClg(position)

    return (
        <>
            <label className="df-align-center" htmlFor={id}>
                {title}
            
            </label>
            <span className={`tooltip ${sizeClg} ${positionClg}`}>
                <span className="wrap-svg">
                    <Tooltip />
                </span>
                <span className="tooltip-text">{desc()}</span>
            </span>
        </>
    )
} 

export const TooltipCustom = ({title, desc, sizeContent, position, icSize, clgTitle}) => {

    const sizeClg = sizeContent === "M" ? "tooltip--m" : ""
    const positionClg = getPositionClg(position)

    return (
        <p className={`df-align-center ${clgTitle}`}>
            {title()}
            <span className={`tooltip ${sizeClg} ${positionClg}`}>
                <span className="wrap-svg">
                    <Tooltip />
                </span>
                <span className="tooltip-text">{desc()}</span>
            </span>
        </p>
    )
}
